module.exports = __webpack_public_path__ + "static/media/Ubuntu-Light.f5a89669.ttf";